import { HERO } from '../Home/homeContent';

/**
 * aieFoldContent.js — the /ai-employees fold's copy layer (Sep 9 2026).
 *
 * Nitish's direction (Sep 9, at the desk): /ai-employees takes home's first
 * screen (HomeFold + the interactive demo frame + the click-to-play film tile)
 * with this page's OWN sub-line kept, "Get started" primary, and a secondary
 * that scrolls to the "What they can do" wall. Every user-visible string the
 * ported fold renders on this page traces to this module, same rule as
 * homeContent.js (a hardcoded label once shipped in a sticky CTA).
 *
 * Trust bullets are home's, imported, never restated: one source.
 */
export const AIE_FOLD = {
  /* The page's existing sub, carried verbatim (his "the subtext remains the
     same"). Sentence 2 still says "shifts" (off core marketing pages since the
     Sep 3 ruling) — kept pending his word, asked Sep 9. */
  subMain:
    'A general-purpose AI worker that owns a role: their own inbox, task board, and memory. They work real shifts and drive the work themselves.',
  subLast: 'You set the goal. They run the work.',
  trust: HERO.trust,
  cta: 'Get started',
  /* Secondary: scrolls to the wall (#aie-how). "See", not "Watch": the
     destination is read, not played (the film has its own tile below). */
  secondary: 'See how it works',
  support: 'Try it free, no credit card needed',
};

/* The product-tour film as a click-to-play tile after the hiring strip, the
   same component and position as home's hire film. Duration measured with
   ffprobe Sep 9 2026: 74.0s. Title pending his word (asked Sep 9). */
export const AIE_TOUR_TILE = {
  title: 'Watch a walkthrough',
  dur: '74s',
  blurb: 'The product tour, start to finish.',
  poster: '/assets/cellcog/product-tour-page-poster.jpg?v=3',
  src: '/assets/cellcog/product-tour-page.mp4',
};
